
import { Component, Vue } from "vue-property-decorator";
import BackgroundLoader from "@/components/Common/BackgroundLoader.vue";

@Component({
  components: {
    BackgroundLoader,
  }
})
export default class EquipoResponsabilidad extends Vue {

  public frame_responsabilidad = "1_2_3_equipo_gest_resp.svg";
  public texto =
    `Antes del inicio de cada obra, se elabora el PLAN DE GESTIÓN MEDIOAMBIENTAL, adaptado a las características del Proyecto y ubicación de la zona de obras.
    <br/><br/>
    El PLAN DE GESTIÓN MEDIAMBIENTAL, supone un plus de respeto al cuidado del medioambiente en la ejecución de obras, que desde INGENIERÍA HUMANA consideramos debe introducirse como algo habitual en toda obra. De esta forma, en nuestros proyectos y obras se toman las siguientes medidas:
    <br/><br/>
    - Planificación Logística de accesos a las obras, minimizando afecciones al entorno.<br/>
    - Gestión de Residuos. Son transportados a las zonas de vertido o tratamiento que corresponden a cada tipo de residuo. construcción y/o mantenimiento de jardines.<br/>
    - Delimitación de zonas de acopio en obra.<br/>
    - Ubicación  de zonas controladas de limpieza de camiones hormigonera.<br/>
    - Instalación de zonas de limpieza de ruedas de camiones en fase de movimiento de tierras.<br/>
    - Estudio de viabilidad de trasplantes de especies vegetales en caso de ser afectadas por la zona de obras.`;
}

